import { DateTime } from "luxon"

export const getCountryCodeFromTimezone = function (timezone: string): string | null {
  if (!timezone) return null

  try {
    const dt = DateTime.local().setZone(timezone)
    const zoneName = dt.zoneName

    if (!zoneName) return null

    // timezone에서 country code 추출
    // 예: "Asia/Seoul" -> "KR", "America/New_York" -> "US"
    const timezoneToCountryMap: Record<string, string> = {
      // Asia
      "Asia/Seoul": "KR",
      "Asia/Tokyo": "JP",
      "Asia/Shanghai": "CN",
      "Asia/Hong_Kong": "HK",
      "Asia/Singapore": "SG",
      "Asia/Bangkok": "TH",
      "Asia/Kuala_Lumpur": "MY",
      "Asia/Manila": "PH",
      "Asia/Jakarta": "ID",
      "Asia/Ho_Chi_Minh": "VN",
      "Asia/Kolkata": "IN",
      "Asia/Dhaka": "BD",
      "Asia/Karachi": "PK",
      "Asia/Dubai": "AE",
      "Asia/Riyadh": "SA",
      "Asia/Jerusalem": "IL",
      "Asia/Tehran": "IR",
      "Asia/Tashkent": "UZ",
      "Asia/Almaty": "KZ",
      "Asia/Novosibirsk": "RU",
      "Asia/Vladivostok": "RU",
      "Asia/Yekaterinburg": "RU",
      "Asia/Krasnoyarsk": "RU",
      "Asia/Novokuznetsk": "RU",
      "Asia/Omsk": "RU",
      "Asia/Ulaanbaatar": "MN",
      "Asia/Urumqi": "CN",
      "Asia/Kashgar": "CN",
      "Asia/Chongqing": "CN",
      "Asia/Harbin": "CN",
      "Asia/Kabul": "AF",
      "Asia/Kathmandu": "NP",
      "Asia/Thimphu": "BT",
      "Asia/Yangon": "MM",
      "Asia/Vientiane": "LA",
      "Asia/Phnom_Penh": "KH",
      "Asia/Pyongyang": "KP",
      "Asia/Ulan_Bator": "MN",
      "Asia/Dili": "TL",
      "Asia/Makassar": "ID",
      "Asia/Jayapura": "ID",
      "Asia/Pontianak": "ID",
      "Asia/Brunei": "BN",
      "Asia/Macau": "MO",
      "Asia/Taipei": "TW",
      "Asia/Choibalsan": "MN",
      "Asia/Hovd": "MN",

      // Europe
      "Europe/London": "GB",
      "Europe/Paris": "FR",
      "Europe/Berlin": "DE",
      "Europe/Rome": "IT",
      "Europe/Madrid": "ES",
      "Europe/Amsterdam": "NL",
      "Europe/Brussels": "BE",
      "Europe/Vienna": "AT",
      "Europe/Zurich": "CH",
      "Europe/Stockholm": "SE",
      "Europe/Oslo": "NO",
      "Europe/Copenhagen": "DK",
      "Europe/Helsinki": "FI",
      "Europe/Warsaw": "PL",
      "Europe/Prague": "CZ",
      "Europe/Budapest": "HU",
      "Europe/Bucharest": "RO",
      "Europe/Sofia": "BG",
      "Europe/Athens": "GR",
      "Europe/Istanbul": "TR",
      "Europe/Moscow": "RU",
      "Europe/Kiev": "UA",
      "Europe/Minsk": "BY",
      "Europe/Riga": "LV",
      "Europe/Tallinn": "EE",
      "Europe/Vilnius": "LT",
      "Europe/Dublin": "IE",
      "Europe/Lisbon": "PT",
      "Europe/Reykjavik": "IS",
      "Europe/Belgrade": "RS",
      "Europe/Zagreb": "HR",
      "Europe/Ljubljana": "SI",
      "Europe/Bratislava": "SK",
      "Europe/Luxembourg": "LU",
      "Europe/Monaco": "MC",
      "Europe/Vatican": "VA",
      "Europe/San_Marino": "SM",
      "Europe/Andorra": "AD",
      "Europe/Malta": "MT",
      "Europe/Cyprus": "CY",
      "Europe/Nicosia": "CY",
      "Europe/Kaliningrad": "RU",
      "Europe/Samara": "RU",
      "Europe/Volgograd": "RU",
      "Europe/Astrakhan": "RU",
      "Europe/Saratov": "RU",
      "Europe/Ulyanovsk": "RU",
      "Europe/Izhevsk": "RU",
      "Europe/Yekaterinburg": "RU",
      "Europe/Omsk": "RU",
      "Europe/Novosibirsk": "RU",
      "Europe/Barnaul": "RU",
      "Europe/Tomsk": "RU",
      "Europe/Novokuznetsk": "RU",
      "Europe/Krasnoyarsk": "RU",
      "Europe/Irkutsk": "RU",
      "Europe/Chita": "RU",
      "Europe/Yakutsk": "RU",
      "Europe/Vladivostok": "RU",
      "Europe/Magadan": "RU",
      "Europe/Sakhalin": "RU",
      "Europe/Srednekolymsk": "RU",
      "Europe/Kamchatka": "RU",
      "Europe/Anadyr": "RU",

      // Americas
      "America/New_York": "US",
      "America/Chicago": "US",
      "America/Denver": "US",
      "America/Los_Angeles": "US",
      "America/Anchorage": "US",
      "America/Adak": "US",
      "America/Phoenix": "US",
      "America/Boise": "US",
      "America/Indiana/Indianapolis": "US",
      "America/Indiana/Knox": "US",
      "America/Indiana/Marengo": "US",
      "America/Indiana/Petersburg": "US",
      "America/Indiana/Tell_City": "US",
      "America/Indiana/Vevay": "US",
      "America/Indiana/Vincennes": "US",
      "America/Indiana/Winamac": "US",
      "America/Kentucky/Louisville": "US",
      "America/Kentucky/Monticello": "US",
      "America/Detroit": "US",
      "America/Toronto": "CA",
      "America/Vancouver": "CA",
      "America/Edmonton": "CA",
      "America/Winnipeg": "CA",
      "America/Regina": "CA",
      "America/Halifax": "CA",
      "America/St_Johns": "CA",
      "America/Whitehorse": "CA",
      "America/Dawson": "CA",
      "America/Yellowknife": "CA",
      "America/Iqaluit": "CA",
      "America/Rankin_Inlet": "CA",
      "America/Resolute": "CA",
      "America/Cambridge_Bay": "CA",
      "America/Pangnirtung": "CA",
      "America/Atikokan": "CA",
      "America/Blanc-Sablon": "CA",
      "America/Creston": "CA",
      "America/Dawson_Creek": "CA",
      "America/Fort_Nelson": "CA",
      "America/Glace_Bay": "CA",
      "America/Goose_Bay": "CA",
      "America/Moncton": "CA",
      "America/Nipigon": "CA",
      "America/Rainy_River": "CA",
      "America/Thunder_Bay": "CA",
      "America/Mexico_City": "MX",
      "America/Tijuana": "MX",
      "America/Monterrey": "MX",
      "America/Chihuahua": "MX",
      "America/Hermosillo": "MX",
      "America/Mazatlan": "MX",
      "America/Cancun": "MX",
      "America/Merida": "MX",
      "America/Matamoros": "MX",
      "America/Ojinaga": "MX",
      "America/Bahia_Banderas": "MX",
      "America/Sao_Paulo": "BR",
      "America/Rio_Branco": "BR",
      "America/Porto_Velho": "BR",
      "America/Manaus": "BR",
      "America/Boa_Vista": "BR",
      "America/Belem": "BR",
      "America/Fortaleza": "BR",
      "America/Recife": "BR",
      "America/Araguaina": "BR",
      "America/Maceio": "BR",
      "America/Bahia": "BR",
      "America/Campo_Grande": "BR",
      "America/Cuiaba": "BR",
      "America/Santarem": "BR",
      "America/Eirunepe": "BR",
      "America/Buenos_Aires": "AR",
      "America/Cordoba": "AR",
      "America/Rosario": "AR",
      "America/La_Rioja": "AR",
      "America/Jujuy": "AR",
      "America/Mendoza": "AR",
      "America/San_Luis": "AR",
      "America/San_Juan": "AR",
      "America/Catamarca": "AR",
      "America/Tucuman": "AR",
      "America/Santiago": "CL",
      "America/Punta_Arenas": "CL",
      "America/Easter_Island": "CL",
      "America/Lima": "PE",
      "America/Bogota": "CO",
      "America/Caracas": "VE",
      "America/Quito": "EC",
      "America/Guayaquil": "EC",
      "America/Galapagos": "EC",
      "America/Asuncion": "PY",
      "America/Montevideo": "UY",
      "America/La_Paz": "BO",
      "America/Sucre": "BO",
      "America/Paramaribo": "SR",
      "America/Cayenne": "GF",
      "America/Guyana": "GY",
      "America/Georgetown": "GY",
      "America/Curacao": "CW",
      "America/Aruba": "AW",
      "America/Barbados": "BB",
      "America/Trinidad": "TT",
      "America/Port_of_Spain": "TT",
      "America/Jamaica": "JM",
      "America/Kingston": "JM",
      "America/Havana": "CU",
      "America/Santo_Domingo": "DO",
      "America/Puerto_Rico": "PR",
      "America/St_Thomas": "VI",
      "America/St_Lucia": "LC",
      "America/St_Vincent": "VC",
      "America/Grenada": "GD",
      "America/Dominica": "DM",
      "America/Antigua": "AG",
      "America/St_Kitts": "KN",
      "America/Guadeloupe": "GP",
      "America/Martinique": "MQ",
      "America/St_Barthelemy": "BL",
      "America/Marigot": "MF",
      "America/Guatemala": "GT",
      "America/Belize": "BZ",
      "America/El_Salvador": "SV",
      "America/Tegucigalpa": "HN",
      "America/Managua": "NI",
      "America/Costa_Rica": "CR",
      "America/Panama": "PA",
      "America/Haiti": "HT",
      "America/Port-au-Prince": "HT",

      // Africa
      "Africa/Cairo": "EG",
      "Africa/Johannesburg": "ZA",
      "Africa/Lagos": "NG",
      "Africa/Casablanca": "MA",
      "Africa/Algiers": "DZ",
      "Africa/Tunis": "TN",
      "Africa/Tripoli": "LY",
      "Africa/Khartoum": "SD",
      "Africa/Addis_Ababa": "ET",
      "Africa/Nairobi": "KE",
      "Africa/Dar_es_Salaam": "TZ",
      "Africa/Kampala": "UG",
      "Africa/Kigali": "RW",
      "Africa/Bujumbura": "BI",
      "Africa/Luanda": "AO",
      "Africa/Lubumbashi": "CD",
      "Africa/Kinshasa": "CD",
      "Africa/Brazzaville": "CG",
      "Africa/Libreville": "GA",
      "Africa/Porto-Novo": "BJ",
      "Africa/Lome": "TG",
      "Africa/Accra": "GH",
      "Africa/Abidjan": "CI",
      "Africa/Dakar": "SN",
      "Africa/Banjul": "GM",
      "Africa/Bissau": "GW",
      "Africa/Conakry": "GN",
      "Africa/Freetown": "SL",
      "Africa/Monrovia": "LR",
      "Africa/Bamako": "ML",
      "Africa/Ouagadougou": "BF",
      "Africa/Niamey": "NE",
      "Africa/Ndjamena": "TD",
      "Africa/Bangui": "CF",
      "Africa/Douala": "CM",
      "Africa/Malabo": "GQ",
      "Africa/Sao_Tome": "ST",
      "Africa/Windhoek": "NA",
      "Africa/Gaborone": "BW",
      "Africa/Maseru": "LS",
      "Africa/Mbabane": "SZ",
      "Africa/Mogadishu": "SO",
      "Africa/Djibouti": "DJ",
      "Africa/Asmara": "ER",
      "Africa/Asmera": "ER",
      "Africa/Blantyre": "MW",
      "Africa/El_Aaiun": "EH",
      "Africa/Harare": "ZW",
      "Africa/Juba": "SS",
      "Africa/Lusaka": "ZM",
      "Africa/Maputo": "MZ",
      "Africa/Nouakchott": "MR",
      "Africa/Timbuktu": "ML",

      // Oceania
      "Pacific/Auckland": "NZ",
      "Pacific/Chatham": "NZ",
      "Pacific/Apia": "WS",
      "Pacific/Fiji": "FJ",
      "Pacific/Guam": "GU",
      "Pacific/Honolulu": "US",
      "Pacific/Johnston": "UM",
      "Pacific/Midway": "UM",
      "Pacific/Niue": "NU",
      "Pacific/Norfolk": "NF",
      "Pacific/Noumea": "NC",
      "Pacific/Pago_Pago": "AS",
      "Pacific/Palau": "PW",
      "Pacific/Pitcairn": "PN",
      "Pacific/Pohnpei": "FM",
      "Pacific/Port_Moresby": "PG",
      "Pacific/Rarotonga": "CK",
      "Pacific/Saipan": "MP",
      "Pacific/Tahiti": "PF",
      "Pacific/Tarawa": "KI",
      "Pacific/Tongatapu": "TO",
      "Pacific/Wake": "UM",
      "Pacific/Wallis": "WF",
      "Australia/Sydney": "AU",
      "Australia/Melbourne": "AU",
      "Australia/Adelaide": "AU",
      "Australia/Perth": "AU",
      "Australia/Darwin": "AU",
      "Australia/Brisbane": "AU",
      "Australia/Hobart": "AU",
      "Australia/Lindeman": "AU",
      "Australia/Lord_Howe": "AU",
      "Australia/Broken_Hill": "AU",
      "Australia/Eucla": "AU",
      "Australia/Currie": "AU",
      "Australia/Canberra": "AU",
      "Australia/ACT": "AU",
      "Australia/NSW": "AU",
      "Australia/North": "NT",
      "Australia/Queensland": "AU",
      "Australia/South": "SA",
      "Australia/Tasmania": "AU",
      "Australia/Victoria": "AU",
      "Australia/West": "WA",

      // UTC and GMT
      UTC: "UN",
      GMT: "UN",
      "Etc/UTC": "UN",
      "Etc/GMT": "UN",
    }

    return timezoneToCountryMap[zoneName] || null
  } catch (error) {
    console.error("Error getting country code from timezone:", error)
    return null
  }
}
